import React, { useEffect, useState } from 'react'
import { mdiDelete, mdiEye, mdiPencil, mdiPlus } from '@mdi/js'
import Button from '@components/Common/Button'
import Section from '@components/Page/Section'
import SectionBox from '@components/Page/Section/box'
import ModalConfirm from '@components/Feedback/ModalConfirm'
import List, { ListColumn, ListLoader, ListMessage, ListOption, ListRow, ListSection } from '@components/Common/List'
import { setCurrentAcessoGrupo } from '@modules/acesso/reducers/grupo/acessoGrupoReducer'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import conditionaRender from '@utils/conditionalRender'
import { getAcessoGrupos, removeAcessoGrupo } from '../../controllers/grupoController'
import ModalCriar from './components/Modals/Criar'
import ModalEditar from './components/Modals/Editar'

const AcessoGrupos: React.FC = () => {

    const dispatch = useAppDispatch()
    const { userData } = useAppSelector(s => s.auth)
    const { acessoGrupos } = useAppSelector(s => s.acessoGrupo)
    const { requestGetAcessoGrupos, requestRemoveAcessoGrupo } = useAppSelector(s => s.requestAcessGrupo)
    const [openModalCriar, setOpenModalCriar] = useState(false)
    const [openModalEditar, setOpenModalEditar] = useState(false)
    const [openModalRemover, setOpenModalRemover] = useState(false)

    const listGrid = "1fr 92px"

    const CR = conditionaRender(requestGetAcessoGrupos, acessoGrupos, true)

    useEffect(() => {
        if(!!userData){
            getAcessoGrupos(dispatch, userData)
        }
    }, [dispatch, userData])

    return(

        <>
            <Section>
                <SectionBox 
                    title = "Grupos de acesso" 
                    padding = {false}
                    right = {
                        <Button
                            icon = {mdiPlus}
                            label = "Criar grupo de acesso"
                            status = "success"
                            onClick = {() => setOpenModalCriar(true)}
                        />
                    }
                >
                    <List name = "acessoGrupos">
                        <ListSection type = "header">
                            <ListRow grid = {listGrid}>
                                {["Perfil", "Opções"].map((item, index) => <ListColumn key = {index}>{item}</ListColumn>)}
                            </ListRow>
                        </ListSection>
                        <ListSection>
                            {CR.NODATA && <ListMessage text = "Nenhum grupo de acesso encontrado" />}
                            {CR.LOADING && <ListLoader />}
                            {CR.DATA && acessoGrupos!.map((item, index) => (
                                <ListRow key = {index} grid = {listGrid} zebra = {index % 2 === 0}>
                                    <ListColumn>{item.nome}</ListColumn>
                                    <ListColumn>
                                        <ListOption
                                            icon = {mdiPencil}
                                            onClick = {() => {
                                                dispatch(setCurrentAcessoGrupo(item))
                                                setOpenModalEditar(true)
                                            }}
                                        />
                                        <ListOption
                                            icon = {mdiDelete}
                                            status = "error"
                                            onClick = {() => setOpenModalRemover(true)}
                                        />
                                        <ListOption
                                            icon = {mdiEye}
                                            link = {`/acesso/grupos/${item.id}`}
                                            onClick = {() => {
                                                dispatch(setCurrentAcessoGrupo(item))
                                            }}
                                        />
                                    </ListColumn>
                                    
                                    <ModalConfirm
                                        open = {openModalRemover}
                                        setOpen = {setOpenModalRemover}
                                        title = "Excluir grupo"
                                        message = "Deseja realmente excluir este grupo?"
                                        loading = {requestRemoveAcessoGrupo.loading}
                                        onConfirm = {() => {
                                            removeAcessoGrupo(dispatch, userData!, { id: item.id, idUsuarioExclusao: userData!.id })
                                        }}
                                    />
                                </ListRow>
                            ))}
                        </ListSection>
                    </List>
                </SectionBox>
            </Section>
            <ModalCriar open = {openModalCriar} setOpen = {setOpenModalCriar} />
            <ModalEditar open = {openModalEditar} setOpen = {setOpenModalEditar} />
        </>

    )

}

export default AcessoGrupos